<div class="form-group row" *ngIf="control.visible" [formGroup]="formGroup">
  <div class="col-md-12">
    <hb-df-control-label [control]="control" (onOverrideValue)="overrideValue()"></hb-df-control-label>
  </div>
  <div class="col-md-12">
    <hb-rich-text [formControlName]="control.key" [editable]="isEditable" class="hb-rich-text" [id]="control.key"> </hb-rich-text>
  </div>
</div>
